// Mutations
export const RAIDEVENT_SETLOADING = 'RAIDEVENT_SETLOADING';
export const RAIDEVENT_UPDATE = 'RAIDEVENT_UPDATE';

const RAIDEVENT_SETERROR = 'RAIDEVENT_SETERROR'

// Actions
export const MAKERAIDHELPERAPICALL = 'MAKERAIDHELPERAPICALL';
export const RAIDEVENT_HANDLEERROR = 'RAIDEVENT_HANDLEERROR';
export const UPDATERAIDEVENTANDSIGNUPS = 'UPDATERAIDEVENTANDSIGNUPS';


import db from '../../firebase/firebase'
import {
  generateUpdatesForObject,
  generateUpdatesForSingleSignup } from '../helpers/updates';
import { doRaidHelperAPICall } from '../helpers/raidhelper'
import connectionJson from '../../config/raidhelperconnection.json'
// import tokenJson from '../../config/raidhelpertoken.json'
  
export default {
  state: () => ({
  }),

  getters: {
  },

  mutations: {
    [RAIDEVENT_SETLOADING] ( state, { raidevent, isloading } ) {
      raidevent.loadingFromRaidHelper = isloading
    },
    [RAIDEVENT_SETERROR] ( state, { raidevent, errormsg } ) {
      raidevent.haserror = true
      raidevent.lasterrormsg = errormsg
    },

  },

  actions: {
    async [MAKERAIDHELPERAPICALL] ( { rootState, commit, dispatch }, { raidevent } ) {

      return doRaidHelperAPICall(
        commit,
        dispatch,
        rootState.guilds.selectedGuild,
        rootState.lockouts.selectedLockout,
        raidevent,
        connectionJson,
        rootState.destinations.specs );

    },
    [RAIDEVENT_HANDLEERROR]( { commit }, { lockout, raidevent, errormsg } ) {
      commit( RAIDEVENT_SETERROR, { raidevent: raidevent, errormsg: errormsg } )

      // Remember when this event was used last (for this lockout)
      let updates = {}
      updates[ 'lockouts/' + lockout['.key'] + '/attributes/lastRaidHelperTriggered' ] = Date.now()

      // Send over all the updates
      return db.ref().update( updates )
    },

    [UPDATERAIDEVENTANDSIGNUPS] ( { rootState }, { guild, lockout, raidevent, eventData, newsignups } ) {
      if( !lockout ) return

      // Gather updates for RaidEvent
      var updates = generateUpdatesForObject(
        'lockouts/' + lockout['.key'] + '/raidevents/' + raidevent['.key'] + '/', eventData)
      // We don't use this code because then it overwrites the object
      // which removes key-value pairs that are not in the eventData
      // like the teams
      // updates[ '/raidevents/' + raidevent['.key'] ] = eventData

      // We later invalidate all signups that are not in "newsignups"
      // so we start with a full set of all signups, and remove the ones we encounter in "newsignups"
      var signupsToInvalidate = {}
      let eventsigns = rootState.signups.signups.filter(
        s => s.eventid == raidevent['.key'] && !s.manualadd ) // excl manual signups
      for( let sign of eventsigns ) {
        signupsToInvalidate[ sign['.key'] ] = true
      }

      // Updates for Signups
      for( let newsignup of newsignups ) {
        generateUpdatesForSingleSignup( updates,
          'lockouts/' + lockout['.key'] + '/signups/',
          'guildMembers/' + guild['.key'] + '/',
          rootState.signups.signups, newsignup, signupsToInvalidate )
      }

      // Signups that are (now) invalid should be added to the updates
      for( let signKey in signupsToInvalidate ) {
        if( signupsToInvalidate[ signKey ]) {
          updates[ 'lockouts/' + lockout['.key'] + '/signups/' + signKey + '/valid' ] = false
        }
      }

      // Remember when this event was used last (for this lockout)
      updates[ 'lockouts/' + lockout['.key'] + '/attributes/lastRaidHelperTriggered' ] = Date.now()

      // Send over all the updates
      return db.ref().update( updates )
    },
  },
}